/** @fileoverview MD3 UI types, we are declaring them here to avoid importing from legacy makyo-md3-ui */

export enum MdIconButtonVariant {
  Standard = 'standard',
  Filled = 'filled',
  FilledTonal = 'filled-tonal',
  Outlined = 'outlined',
  Elevated = 'elevated',
}

export enum MdShape {
  None = 'none',
  ExtraSmall = 'extra-small',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  ExtraLarge = 'extra-large',
  Full = 'full',
}

export enum MdFabShape {
  Rounded = 'rounded',
  Square = 'square',
  Circle = 'circle',
  DropBotLeft = 'drop-bl',
  DropBotRight = 'drop-br',
  DropTopLeft = 'drop-tl',
  DropTopRight = 'drop-tr',
}

export enum AspectRatio {
  Auto = 'auto',
  OneByOne = '1:1',
  FourByThree = '4:3',
  SixteenByNine = '16:9',
  ThreeByTwo = '3:2',
  FiveByFour = '5:4',
  SevenByFive = '7:5',
  EightByTen = '8:10',
  NineBySixteen = '9:16',
  TwoByOne = '2:1',
  TwentyOneByNine = '21:9',
}

export function getRatioLabel(ratio: AspectRatio): string {
  switch (ratio) {
    case AspectRatio.FourByThree:
      return '4:3 (Standard)'
    case AspectRatio.SixteenByNine:
      return '16:9 (Widescreen)'
    case AspectRatio.ThreeByTwo:
      return '3:2 (35mm Film)'
    case AspectRatio.FiveByFour:
      return '5:4 (Large Format)'
    case AspectRatio.SevenByFive:
      return '7:5 (Traditional Print)'
    case AspectRatio.EightByTen:
      return '8:10 (Common Print)'
    case AspectRatio.NineBySixteen:
      return '9:16 (Vertical)'
    case AspectRatio.TwoByOne:
      return '2:1 (Panoramic)'
    case AspectRatio.TwentyOneByNine:
      return '21:9 (Ultra-wide)'
    case AspectRatio.OneByOne:
      return '1:1 (Square)'
    case AspectRatio.Auto:
    default:
      return 'auto'
  }
}

export enum MdGalleryLayout {
  Carousel = 'carousel',
  Grid = 'grid',
  List = 'list',
  Masonry = 'masonry',
}

export enum MdDataListColorStyle {
  None = 'none',
  Stripped = 'stripped',
  StrippedTitle = 'stripped-title',
  StrippedContent = 'stripped-content',
  TitleBg = 'title-bg',
  // TitleText = 'title-text',
  ContentBg = 'content-bg',
  // ContentText = 'content-text',
  Full = 'full',
}

export type MdTextFieldBaseVariant = 'filled' | 'filled-outlined' | 'outlined'

interface ImageArrayValue {
  CreatedAt: Date
  Title: string
  Description: string
  Tags: string[]
  Width: number
  Height: number
  Format: string
  Size: number
  Url: string
  Owner: string
}
export type MdImageUploadValue = File | string | ImageArrayValue

export enum CardVariant {
  Elevated = 'elevated',
  Outlined = 'outlined',
  Filled = 'filled',
}

export enum MediaType {
  Image = 'image',
  Video = 'video',
  Lottie = 'lottie',
  Embed = 'embed',
  Icon = 'icon',
}
